import { render, staticRenderFns } from "./PerfilesView.vue?vue&type=template&id=4ae35c51"
import script from "./PerfilesView.vue?vue&type=script&lang=js"
export * from "./PerfilesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports